import {
  collection,
  CollectionReference,
  doc,
  getDocs,
  onSnapshot,
  query,
  QuerySnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
  orderBy
} from 'firebase/firestore'
import { firestore } from '@/modules/firebase'

const participationCollection = collection(
  firestore,
  'participations'
) as CollectionReference<Participation>

export function getParticipationDoc(participationId?: string) {
  if (participationId) {
    return doc(participationCollection, participationId)
  }
  return doc(participationCollection)
}

export async function addParticipation(
  userId: string,
  eventId: string,
  state: ParticipationType = 'pending'
) {
  const docRef = doc(participationCollection)
  return setDoc(docRef, {
    id: docRef.id,
    participantId: userId,
    lastUpdated: serverTimestamp(),
    state,
    eventId
  })
}

export async function updateParticipation(
  participationId: string,
  newState: ParticipationType
) {
  const docRef = doc(participationCollection, participationId)
  return updateDoc(docRef, {
    state: newState,
    lastUpdated: serverTimestamp()
  })
}

export async function getEventParticipation(eventId: string) {
  const participationQuery = query(
    participationCollection,
    where('eventId', '==', eventId)
  )
  const querySnapshot = await getDocs(participationQuery)
  return querySnapshot.docs.map((doc) => doc.data())
}

export function getEventParticipationListener(
  eventId: string,
  onNext: (snapshot: QuerySnapshot<Participation>) => void
) {
  const participationQuery = query(
    participationCollection,
    where('eventId', '==', eventId),
    orderBy('lastUpdated', 'asc')
  )
  return onSnapshot(participationQuery, onNext)
}
